import React from 'react';
import Sidebar from './Sidebar';

// App-wide layout: collapsible desktop sidebar + page content.
// Mobile keeps the existing per-page hamburger (MobileMenu), so the sidebar is desktop-only.
export const AppShell = ({ children }) => {
  return (
    <div className="md:flex bg-[#F8FAFC] dark:bg-gray-900" data-testid="app-shell">
      <Sidebar />
      <div className="flex-1 min-w-0">{children}</div>
    </div>
  );
};

export default AppShell;
